<script>
/**
 * 여기서 value 는 v-model 로 사용하지 않습니다.
 * 값을 받을 때는 value 를 통해서만 받고
 * 값을 부모 컴포넌트로 보낼 때는 input event 를 통해서만 합니다.
 */
import FormTableBaseKeyHelper from "./FormTableBaseKeyHelper";

    export default {
        name: "FormTableBaseElement",
        mixins: [FormTableBaseKeyHelper],
        props: {
            value: undefined,
            // 기본적으로 편집불가능한 요소 입니다.
            editable: {
                type: Boolean,
                default: false,
            },
            optionsData: {
                type: Object,
                default: () => {},
            },
            // TD 에 대한 이벤트 핸들러 객체입니다.
            on: {
                type: Object,
                default: () => {},
            },
            placeholder: {
                type: String,
                default: undefined,
            },
        },
        data() {
            return {
                model: this.value,
            };
        },
        computed: {
            clazz() {
                let clazz = "form-table__input tabable";
                return clazz;
            },

            options() {
                return !this.optionsData || typeof this.optionsData !== "object" ? {} : this.optionsData;
            },

            tabindex() {
                return this.editable ? 6 : undefined;
            },
        },
        watch: {
            value(newValue, oldValue) {
                if (!this.checkDirty(newValue, oldValue)) return;
                this.model = this.value;
            },

            model() {
                this.$emit("input", this.model);
            },
        },
        mounted() {
        },
        methods: {
            /**
             * value가 변경될 때 더티체크를 수행합니다. 반환 값이 false 이면 값을 변경하지 않습니다.
             * @return Boolean
             */
            checkDirty(newValue, oldValue) {
                return true;
            },
        },
    }
</script>